// client/src/components/PushToggle.js — Maxula
import React, { useEffect, useState } from 'react';
import { FiBell, FiBellOff } from 'react-icons/fi';
import { getPushState, subscribePush, unsubscribePush } from '../utils/push';

const MAGENTA = '#E11D79';

export default function PushToggle() {
  const [supported, setSupported] = useState(true);
  const [subscribed, setSubscribed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    let on = true;
    (async () => {
      const st = await getPushState();
      if (!on) return;
      setSupported(st.supported);
      setSubscribed(st.subscribed);
    })();
    return () => { on = false; };
  }, []);

  if (!supported) {
    return <span style={{ color: '#6b7280', fontSize: 13 }}>Non supporté par ce navigateur</span>;
  }

  const toggle = async () => {
    setBusy(true); setMsg('');
    try {
      if (subscribed) { await unsubscribePush(); setSubscribed(false); setMsg('Désactivées'); }
      else { await subscribePush(); setSubscribed(true); setMsg('Activées'); }
    } catch (e) {
      setMsg(e && e.message ? e.message : 'Erreur');
    } finally { setBusy(false); }
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
      {msg ? <span style={{ fontSize: 12, color: '#6b7280' }}>{msg}</span> : null}
      <button
        type="button"
        onClick={toggle}
        disabled={busy}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          padding: '9px 16px', borderRadius: 8, fontWeight: 700, fontSize: 13,
          cursor: busy ? 'default' : 'pointer', whiteSpace: 'nowrap',
          border: subscribed ? '1px solid #e5e7eb' : 'none',
          background: subscribed ? '#fff' : MAGENTA,
          color: subscribed ? '#374151' : '#fff',
          opacity: busy ? 0.7 : 1
        }}
      >
        {subscribed ? <FiBellOff size={16} /> : <FiBell size={16} />}
        {subscribed ? 'Désactiver' : 'Activer'}
      </button>
    </span>
  );
}
